export const mapValuesToForm = values =>
  values && { ...values, activeState: Boolean(values.activeState) };

export const mapFormToValues = values => ({ ...values, activeState: Number(values.activeState) });
